// @flow
import type { Action, User } from '../types';
import * as constants from '../constants/userConstants';

export type State = $ReadOnly<{
    initialized: boolean,
    value: null | User,
    status: $ReadOnly<{
        isLoading: boolean,
        error: boolean
    }>
}>;

const initialState = {
    initialized: false,
    value: null,
    status: {
        isLoading: false,
        error: false
    }
};

export default function user(state: State = initialState, action: Action): State {
    switch(action.type) {
        case constants.LOGGING_IN:
            return {
                ...state,
                status: {
                    isLoading: !action.data,
                    error: false
                }
            };

        case constants.SET_USER:
            return {
                ...state,
                initialized: true,
                value: action.data,
                status: {
                    isLoading: false,
                    error: false
                }
            };

        default:
            return state;
    }
}